export namespace ContactTranslations {
  export const common = {
    contact: 'contact',
  } as const;

  export const error = {
    contactsUnableToLoadError: 'contactsUnableToLoadError',
  } as const;
}
